module.exports = __webpack_public_path__ + "static/img/top.c2e13589.png";